// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__2WI8u"};